import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

const Impersonate = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Setting up session...');

  useEffect(() => {
    const access = searchParams.get('access');
    const refresh = searchParams.get('refresh');
    const userParam = searchParams.get('user');

    if (!access || !refresh || !userParam) {
      setStatus('Missing impersonation parameters.');
      return;
    }

    try {
      const userData = JSON.parse(userParam);

      // Set tokens in sessionStorage (per-tab isolation)
      api.setTokens(access, refresh);
      api.setUser(userData);

      setStatus(`Logged in as ${userData.email || userData.full_name || 'user'}. Redirecting...`);

      // Redirect to dashboard
      setTimeout(() => {
        navigate('/dashboard', { replace: true });
      }, 500);
    } catch (err) {
      setStatus('Failed to parse user data.');
    }
  }, [searchParams, navigate]);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      fontFamily: 'inherit',
    }}>
      <div style={{
        textAlign: 'center',
        padding: '2rem',
        background: '#fffbeb',
        border: '1px solid #f59e0b',
        borderRadius: '12px',
        maxWidth: '400px',
      }}>
        <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>🔑</div>
        <div style={{ fontWeight: 600, color: '#92400e', marginBottom: '0.5rem' }}>Admin Impersonation</div>
        <div style={{ color: '#78716c', fontSize: '0.9rem' }}>{status}</div>
      </div>
    </div>
  );
};

export default Impersonate;
